export const aboutText = [
  `       
נתונה תמונה שבנויה ממספר קטן של פיקסלים ("רזולוציה נמוכה"), ורוצים להציג אותה בהגדלה על מסך איכותי. כיצד ניתן להגדיל אותה, כדי שתיראה נעימה ולא מפוקסלת?
        `,

  `
השיטה הפשוטה להגדלה היא שִכפול פיקסלים. לדוגמה, נתון ריבוע עם 2x2 פיקסלים. אם נרצה להציג אותו כריבוע בעל 300x300  פיקסלים ניצור ארבעה ריבועים (50x50) ונצבע כל אחד בצבע הפיקסל המתאים בריבוע המקורי. זאת השיטה הבסיסית להגדלה, אולם התוצאה יוצאת מפוקסלת.
`,
  `
דרך אחרת היא לעשות שינויי צבע הדרגתיים. נעתיק את ארבעת הפיקסלים בריבוע הקטן לקודקודי הריבוע הגדול, ונצבע את הפיקסלים ביניהם כך ששינויי הצבע יהיו  הדרגתיים, וההפרש בין הערכים המספריים של צבעי פיקסלים שכנים יישאר קבוע כשנעים לאורך שורה או עמודה מסוימת. שיטה זו נקראת "bilinear interpolation".   אתם מוזמנים לנסות ולהתרשם בעצמכם.
`,
];
